export const AIM_APP_ICON = 'fad fa-bullseye-arrow';
export const PLATFORM_APP_ICON = 'fas fa-microchip';
export const CHAT_APP_ICON = 'fad fa-message-bot';
export const PSF_APP_ICON = 'fad fa-message-check';
